const DarkBlue = 'hsl(209, 23%, 22%)';
const VeryDarkBlue = 'hsl(207, 26%, 17%)';
const VeryDarkBlue1 = 'hsl(200, 15%, 8%)';
const DarkGray = 'hsl(0, 0%, 52%)';
const VeryLightGray = 'hsl(0, 0%, 98%)';
const White = 'hsl(0, 0%, 100%)';

export const lightTheme = {
    mainBackground: VeryLightGray,
    secondaryBackground: White,
    textColorPrimary: VeryDarkBlue1,
    textColorSecondary: DarkGray,
}

export const darkTheme = {
    mainBackground: VeryDarkBlue,
    secondaryBackground: DarkBlue,
    textColorPrimary: White,
    textColorSecondary: DarkGray,
}

